"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let SET_ROOT = '';
let COPY_FILES_TOGGLE_OVERLAY = '';
let COPY_CHANGE_EXPAND = '';
let COPY_FILES_REQUEST = '';
let COPY_FILES_SUCCESS = '';
let COPY_FILES_FAILURE = '';
let COPY_SELECT_TARGET = '';
let COPY_FILES_RESET = '';
let FETCH_TREE_REQUEST = '';
let FETCH_TREE_SUCCESS = '';
let FETCH_TREE_FAILURE = '';
let SELECT_FILE = '';
let COPY_OR_MOVE_FILES_ROOT_EXPANDED_REQUEST = '';
let USER_TOGGLE_COPY_OR_MOVE_RESULT = '';
let CLEAR = '';
let REMOVE_ITEMS_FROM_TREE = '';
function default_1(namespace) {
    SET_ROOT = `@sok/modules/files/tree/${namespace}/SET_ROOT`;
    COPY_FILES_TOGGLE_OVERLAY = `@sok/modules/files/tree/${namespace}/COPY_FILES_TOGGLE_OVERLAY`;
    COPY_CHANGE_EXPAND = `@sok/modules/files/tree/${namespace}/CHANGE_EXPAND`;
    COPY_FILES_REQUEST = `@sok/modules/files/tree/${namespace}/COPY_FILES_REQUEST`;
    COPY_FILES_SUCCESS = `@sok/modules/files/tree/${namespace}/COPY_FILES_SUCCESS`;
    COPY_FILES_FAILURE = `@sok/modules/files/tree/${namespace}/COPY_FILES_FAILURE`;
    COPY_FILES_RESET = `@sok/modules/files/tree/${namespace}/COPY_FILES_RESET`;
    COPY_SELECT_TARGET = `@sok/modules/files/tree/${namespace}/COPY_SELECT_TARGET`;
    FETCH_TREE_REQUEST = `@sok/modules/files/tree/${namespace}/FETCH_TREE_REQUEST`;
    FETCH_TREE_SUCCESS = `@sok/modules/files/tree/${namespace}/FETCH_TREE_SUCCESS`;
    FETCH_TREE_FAILURE = `@sok/modules/files/tree/${namespace}/FETCH_TREE_FAILURE`;
    SELECT_FILE = `@sok/modules/files/tree/${namespace}/SELECT_FILE`;
    USER_TOGGLE_COPY_OR_MOVE_RESULT = `@sok/modules/files/tree/${namespace}/COPY_TOGGLE_RESULT`;
    COPY_OR_MOVE_FILES_ROOT_EXPANDED_REQUEST = `@sok/modules/files/tree/${namespace}/COPY_OR_MOVE_FILES_ROOT_EXPANDED_REQUEST`;
    CLEAR = `@sok/modules/files/tree/${namespace}/CLEAR`;
    REMOVE_ITEMS_FROM_TREE = `@sok/modules/files/tree/${namespace}/REMOVE_ITEMS_FROM_TREE`;
    return {
        SET_ROOT,
        COPY_FILES_TOGGLE_OVERLAY,
        COPY_CHANGE_EXPAND,
        COPY_FILES_REQUEST,
        COPY_FILES_SUCCESS,
        COPY_FILES_FAILURE,
        COPY_FILES_RESET,
        COPY_SELECT_TARGET,
        FETCH_TREE_REQUEST,
        FETCH_TREE_SUCCESS,
        FETCH_TREE_FAILURE,
        SELECT_FILE,
        USER_TOGGLE_COPY_OR_MOVE_RESULT,
        COPY_OR_MOVE_FILES_ROOT_EXPANDED_REQUEST,
        CLEAR,
        REMOVE_ITEMS_FROM_TREE
    };
}
exports.default = default_1;
//# sourceMappingURL=actionTypes.js.map